// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__17rhb","list":"PatternAutocomplete_list__1KEDu"};